import App from "@bloglovin/inspire-engine/App";
import { useAppFileStore } from "%/dynamic-component-editor/stores/app-file-store";
import { useConfigurationStore } from "%/dynamic-component-editor/stores/configuration-store";
import CommitAction from "%/dynamic-component-editor/options/commit-action";
import MediaTypeField from "%/dynamic-component-editor/options/media-type-field";
import {
  MEDIA_TYPE_ANY,
  MEDIA_TYPE_AUDIO,
  MEDIA_TYPE_DOCUMENT,
  MEDIA_TYPE_IMAGE,
  MEDIA_TYPE_VIDEO,
} from "%/constants/media-picker-constants";

const DEFAULT_APP_NAME = "";
const FILENAME_FIELD = "draftFileName";
const FILE_TYPE_FIELD = "draftFileType";

export const ACCEPTABLE_FILE_TYPES = {
  [MEDIA_TYPE_IMAGE]: ["image/*"],
  [MEDIA_TYPE_VIDEO]: ["video/*"],
  [MEDIA_TYPE_AUDIO]: ["audio/*"],
  [MEDIA_TYPE_DOCUMENT]: [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "application/rtf",
    "text/plain",
    "text/csv",
    "text/markdown",
  ],
  [MEDIA_TYPE_ANY]: [],
};

export default {
  data() {
    return {
      isUploading: false,
      uploadError: "",
    };
  },
  computed: {
    uploadAppName() {
      return this.elementContext?.appName || DEFAULT_APP_NAME;
    },
    publicationId() {
      return useConfigurationStore().publicationId;
    },
    mediaType() {
      const fieldName = this.getOptionValue(MediaTypeField);
      if (!fieldName) {
        return MEDIA_TYPE_ANY;
      }
      return this.siblingFieldValue(fieldName) || MEDIA_TYPE_ANY;
    },
    acceptableFileTypes() {
      return ACCEPTABLE_FILE_TYPES[this.mediaType] ?? [];
    },
    uploadedFileUrl: {
      get() {
        return this.valueFromContext;
      },
      set(value) {
        if (!this.editMode) {
          this.valueFromContext = value;
        }
      },
    },
  },
  methods: {
    uploadFile(file) {
      if (this.editMode || !file) {
        return;
      }
      this.isUploading = true;
      this.uploadError = "";
      useAppFileStore().uploadAppFile({
        appName: this.uploadAppName,
        publicationId: this.publicationId,
        mediaType: this.mediaType,
        file,
      }, (url, stored) => {
        this.uploadedFileUrl = url;
        this.writeDraftFields(file, stored);
        this.commitUpload();
      }, message => {
        this.uploadError = message;
      }, () => {
        this.isUploading = false;
      });
    },
    writeDraftFields(file, stored) {
      if (!this.contextItem || !this.entityType) {
        return;
      }
      App.get(this.resolvedAppName).updateSpecificEntityFields(this.entityType, this.contextItem.entityPkUrlVars, {
        [FILENAME_FIELD]: file.name ?? "",
        [FILE_TYPE_FIELD]: stored?.media_type ?? this.mediaType,
      });
    },
    async commitUpload() {
      await this.$nextTick();
      this.triggerNamedAction(this.getOptionValue(CommitAction));
    },
  },
};
